document.addEventListener('DOMContentLoaded', function () {
  const sidebar = document.querySelector('.sidebar');
  if (!sidebar) return;

  sidebar.querySelectorAll('.sidebar-toggle').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const submenu = btn.nextElementSibling;
      const icon = btn.querySelector('.icon');

      if (!submenu) return;

      submenu.classList.toggle('open');
      if (icon) icon.textContent = submenu.classList.contains('open') ? '−' : '+';
    });
  });
});
